import { Zap, Star, Crown } from 'lucide-react'

/**
 * Single source of truth for subscription tiers — used by Landing and Pricing.
 *
 * TODO(billing): annual Stripe price IDs don't exist yet. Create annual prices
 * in the Stripe dashboard (monthly × 10 = "2 months free") and paste the IDs
 * into `annualPriceId` below. While null, the annual checkout path shows a
 * "launching soon" fallback instead of redirecting.
 */
export const PLANS = [
  {
    tier: 'Basic',
    monthlyPrice: 8,
    annualPrice: 80, // 8 × 10 — two months free
    slices: 4,
    monthlyPriceId: 'price_1Ryl4JI3np9rVB0EWEbmAwVH',
    annualPriceId: null,
    icon: Zap,
    color: 'text-blue-500',
    featured: false,
    features: [
      'Unlimited streaming — full library',
      'HD streaming quality',
      'Watch on up to 2 devices at once',
      '4 slices/month to support creators',
    ],
  },
  {
    tier: 'Standard',
    monthlyPrice: 15,
    annualPrice: 150, // 15 × 10 — two months free
    slices: 8,
    monthlyPriceId: 'price_1RynSsI3np9rVB0ErH1N9bh5',
    annualPriceId: null,
    icon: Star,
    color: 'text-purple-500',
    featured: true,
    features: [
      'Everything in Basic',
      'Access to the Kinora Guild (crew network)',
      'Access to Slice Cinema',
      'Watch on up to 4 devices',
      '8 slices/month to support creators',
      'Back crowdfunding campaigns',
    ],
  },
  {
    tier: 'Premium',
    monthlyPrice: 25,
    annualPrice: 250, // 25 × 10 — two months free
    slices: 16,
    monthlyPriceId: 'price_1RykvGI3np9rVB0EZuhVFeZo',
    annualPriceId: null,
    icon: Crown,
    color: 'text-yellow-500',
    featured: false,
    features: [
      'Everything in Standard',
      '4K streaming + early access to new releases',
      'Unlimited devices',
      'Priority support',
      '16 slices/month to support creators',
    ],
  },
]

/** Price anchor: per-day cost of a plan, e.g. "$0.49". */
export function perDay(price) {
  return `$${(price / 30).toFixed(2)}`
}
